import * as React from 'react';
import { capitalize } from 'lodash';
import AvatarWithText from 'components/AvatarWithText';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import UserAvatar from 'users/components/UserAvatar';
import { SingleChatStreamViewMember } from 'chat/components/SingleChatStreamView';

import './styles/SingleChatStreamViewSidebar.scss';

type Props = {
  chatTitle: string;
  chatMemberData: SingleChatStreamViewMember[];
};

export default function SingleChatStreamViewSidebar(props: Props) {
  return (
    <div className="SingleChatStreamViewSidebar">
      <Row>
        <Heading level="6">Group name</Heading>
        <Text size="medium">{props.chatTitle}</Text>
      </Row>
      <Heading level="6" data-test="number-of-people-heading">
        {props.chatMemberData.length} people
      </Heading>
      {props.chatMemberData.map((member, index) => (
        <React.Fragment key={member.displayName}>
          <AvatarWithText
            data-test="chat-member-row"
            level="secondary"
            avatar={
              <UserAvatar
                user={{ initials: member.initials, profilePictureUrl: member.profilePictureUrl }}
              />
            }
            title={
              <Text size="medium" weight="normal">
                <MediaObject gutter="xsmall" center>
                  <span>{member.displayName}</span>
                  <Text color="graphite">{capitalize(member.role)}</Text>
                </MediaObject>
              </Text>
            }
          />
          {index < props.chatMemberData.length - 1 && <Divider size="small" />}
        </React.Fragment>
      ))}
    </div>
  );
}
